import { useRouter } from "next/router";
import ForgotPasswordForm from "@/PageComponents/ForgotPassword/SendResetPasswordForm";
import CompleteResetPasswordForm from "@/PageComponents/ForgotPassword/CompleteResetPasswordForm";
import AuthSplitLayout from "@/PageComponents/Auth/AuthSplitLayout";

const ForgotPasswordComponent = (props: any) => {
    const { query } = useRouter();

    return (
        <AuthSplitLayout contentWidth={410}>
            {query.resetToken ? (
                <CompleteResetPasswordForm token={query.resetToken} />
            ) : (
                <ForgotPasswordForm />
            )}
        </AuthSplitLayout>
    );
};

export default ForgotPasswordComponent;
